import { Badge, Button, Tooltip } from 'antd'
import CustomSpin from '../../../elements/CustomSpin'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import InfoText from '../../../elements/InfoText'
import Status from '../../../elements/Status'
import CustomTable from '../../../elements/Table/CustomTable'
import { isEmpty } from 'lodash'
import { strVal } from '../../../modules/Utils'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import UpperCaseCell from "../../../elements/Table/Cells/UpperCaseCell";

const NewContractButton = withRouter(({ history, lender, member }) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      size={'small'}
      onClick={() => {
        history.push({
          pathname: 'contracts/new',
          state: { lender, member },
        })
      }}>
      New{' '}
    </Button>
  )
})

function Contracts(props) {
  const { member, lender, loading } = props
  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => (
        <div>
          {original.default === true && (
            <Tooltip placement="top" title="Default Contract">
              <Badge
                dot
                style={{
                  background: '#2db731',
                }}
              />
            </Tooltip>
          )}
          <Link
            to={{
              pathname: `/finance/lenders/${member._key}/contracts/${original._key}/view`,
              state: {
                contract: original,
                lender,
                member,
              },
            }}
            style={{ marginLeft: '10px' }}>
            {value}
          </Link>
        </div>
      ),
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: UpperCaseCell
    },
    {
      Header: 'Account Name',
      accessor: 'bank.accountName',
    },
    {
      Header: 'Title',
      accessor: 'title',
    },
    {
      Header: 'Company',
      accessor: 'company',
      Cell: ({ value }) => strVal(value, 'fn'),
    },
    {
      Header: 'Document Status',
      accessor: 'status',
      Cell: ({ value }) => <Status value={value} tooltip={false} />,
    },
  ]

  console.log('0000', { lender })
  const { data: contracts, fetching, fetchURL: fetch } = useFetchURL(
    `/foxxapi/lenders/${lender._key}/contracts/`,
    [lender],
    isEmpty(lender._key)
  )

  return (
    <CustomSpin spinning={loading}>
      <CustomTable
        CreateButton={() => <NewContractButton {...{ lender, member }} />}
        fetch={fetch}
        loading={fetching}
        columns={columns}
        data={contracts}
        pagination={false}
      />
      <InfoText text={'Click on contract code to view contract'} />
    </CustomSpin>
  )
}

export default Contracts
